import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import useUserTier from "../../../hooks/useUserTier";
import { getProfileData } from "../../../redux/profile/actions";
import { message, Modal, QRCode, Spin } from "antd";
import styles from "../../../styles/Components/pricing-plan/PricingDiscountButton.module.css";
import { LuScanLine } from "react-icons/lu";

const DiscountProcessModal = ({ show, setShow, type }) => {
  const {
    main: { userData },
    alertSystem: { telegramBotToken, telegramBotTokenStatus },
  } = useSelector((state) => state);

  const [showQrCode, setShowQrCode] = useState(false);
  const intervalRef = useRef(null);

  const dispatch = useDispatch();

  const { canTry } = useUserTier();

  const qrValue = `https://app-responsive.cryptocrispy.com.au/verify-location?user=${
    userData?.["custom:custom_username"]
  }&email=${userData?.email}&token=${telegramBotToken}`;

  const closeModal = () => {
    setShowQrCode(false);
    setShow(false);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleGenerateButtonClick = () => {
    setShowQrCode(true);

    // Clear any existing interval before starting a new one
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    // check profile data if it has not been vrefied yet
    if (canTry) {
      intervalRef.current = setInterval(() => {
        dispatch(
          getProfileData(userData?.email, userData?.["custom:custom_username"]),
        );
      }, 5000);
    }
  };

  // Clear interval on unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      message.destroy("checking-message");
    };
  }, []);

  useEffect(() => {
    if (!canTry) {
      message.loading({
        content: "Checking...",
        key: "checking-message", // Unique key for the message
        duration: 60,
      });
    }
  }, [canTry]);

  return (
    <Modal open={show} onCancel={closeModal} width={400} footer={null} centered>
      {type === "alert" && (
        <div className={`${styles.alertContent} ${showQrCode ? styles.reverse : ""}`}>
          <h4 className={styles.alertTitle}>
            <LuScanLine color="#0C4CFC" size={26} />
            Scan QR code using your mobile device to log in, and complete the
            action there.
          </h4>

          {!showQrCode ? (
            <span
              className={styles.generateBtn}
              onClick={handleGenerateButtonClick}
            >
              Generate QR code
            </span>
          ) : telegramBotTokenStatus === "loading" ? (
            <div className={styles.loader}>
              <Spin />
            </div>
          ) : (
            <QRCode value={qrValue} size={200} level="H" />
          )}
        </div>
      )}

      {/*{type === "process" && (*/}
      {/*  <div className={styles.alertContent}>{isLoading ? <Spin /> : "t"}</div>*/}
      {/*)}*/}
    </Modal>
  );
};

export default DiscountProcessModal;
